module.exports = __webpack_public_path__ + "img/16.eb290b03.png";